export const formatCentsToBRL = (cents) => {
  const value = Number(cents || 0) / 100;
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const formatVariants = (variants, withPrice = false) => {
  const groups = new Map();
  (variants || []).forEach((v) => {
    const key = `${v.name}|${v.extraCents || 0}`;
    const g = groups.get(key) || { name: v.name, extraCents: v.extraCents || 0, qty: 0 };
    g.qty += 1;
    groups.set(key, g);
  });
  return [...groups.values()]
    .map((g) => {
      const label = g.qty > 1 ? `${g.qty}x ${g.name}` : g.name;
      return withPrice ? `${label} (+${formatCentsToBRL(g.extraCents * g.qty)})` : label;
    })
    .join(', ');
};

export const parseBRLToCents = (input) => {
  if (input === null || input === undefined) return 0;
  const digits = String(input).replace(/\D/g, '');
  if (!digits) return 0;
  // digits already represent cents when user types (last two digits)
  return parseInt(digits, 10);
};

export const getActiveSizes = (item) =>
  (item?.sizes || []).filter((s) => s.active !== false);

export const itemHasMultipleSizes = (item) =>
  item?.hasMultipleSizes ?? getActiveSizes(item).length > 1;

export const getItemMinPriceCents = (item) => {
  const sizes = getActiveSizes(item);
  if (!sizes.length) return 0;
  return Math.min(...sizes.map((s) => s.priceCents));
};

export const formatItemPrice = (item) => {
  const sizes = getActiveSizes(item);
  if (!sizes.length) return '—';
  if (!itemHasMultipleSizes(item)) return formatCentsToBRL(sizes[0].priceCents);
  return `A partir de ${formatCentsToBRL(getItemMinPriceCents(item))}`;
};
